import { render, staticRenderFns } from "./_sender-email-addresses.vue?vue&type=template&id=7f5ff0f0"
import script from "./_sender-email-addresses.vue?vue&type=script&lang=js"
export * from "./_sender-email-addresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports